import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchGeneralLedger } from '@/renderer/services/accountingReportingService';
import type { AccountingReportFilterParams } from '@/renderer/types/accounting';

export function useGeneralLedger(
  params: AccountingReportFilterParams,
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.accounting.generalLedger(params),
    queryFn: async () => {
      const result = await fetchGeneralLedger(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch general ledger');
      }
      return result.data;
    },
    enabled: !!params.companyId && enabled,
    placeholderData: keepPreviousData,
  });
}
